import React, { FC } from 'react';
import Link from 'next/link';
import styles from './digando-breadcrumb.module.scss';
import classNames from 'classnames';
import { breadcrumbSchema } from '../../schema.org/breadcrumb.schema';
import { isFeatureFlagEnabled } from '../../lib/environment';

export type DigandoBreadcrumbItem = { href: string; name: string }

export type DigandoBreadcrumbProps = {
  items: DigandoBreadcrumbItem[];
  actualPage: string;
  invert?: boolean;
}

export const DigandoBreadcrumb: FC<DigandoBreadcrumbProps> = ({ items, actualPage, invert = false }) => {
  return <>
    {isFeatureFlagEnabled('isSchemaMarkupEnabled') && (
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema(items)) }}
      />
    )}

    <div className={classNames({
      [styles.digandoBreadcrumb]: true,
    })}>
      <ol>
        {items.map((link) => (
          <li className={styles.breadcrumbItem} key={link.href}>
            <Link href={link.href} passHref>
              {link.name}
            </Link>
          </li>
        ))}

        <li className={classNames({
          [styles.breadcrumbItem]: true,
          [styles.isCurrentRoute]: true,
        })}>
          {actualPage}
        </li>
      </ol>
    </div>
  </>;
};
